import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Mail, ChevronRight, CheckCircle2, ArrowLeft } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../lib/auth";

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || loading) return;
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email: email.trim() });
      setSent(true);
    } catch (err) {
      toast.error("Erro ao enviar pedido. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-[#0E2452] pt-32 pb-20 px-6 md:px-12" data-testid="forgot-password-page">
      <div className="max-w-md mx-auto">
        <div className="text-center mb-8">
          <div className="section-label mb-2 justify-center">// Recuperar Acesso</div>
          <h1 className="font-display font-bold text-4xl md:text-5xl uppercase text-white leading-tight">
            Esqueceu a <span className="text-[#FF5A00]">palavra-passe?</span>
          </h1>
          <p className="text-white/60 text-sm font-body mt-3">
            Sem stress. Coloque o seu email e enviamos-lhe um link para definir uma nova.
          </p>
        </div>

        <div className="rounded-2xl border border-[#2F568F] bg-[#0B1D44] p-6 md:p-8">
          {sent ? (
            <div data-testid="forgot-success" className="text-center py-4">
              <div className="w-14 h-14 rounded-full bg-emerald-500/15 border-2 border-emerald-500/50 flex items-center justify-center mx-auto mb-4">
                <CheckCircle2 className="w-7 h-7 text-emerald-400" />
              </div>
              <h2 className="font-display font-bold text-white text-xl uppercase mb-2">Verifique o seu email</h2>
              <p className="text-white/70 font-body text-sm leading-relaxed mb-1">
                Se existir uma conta associada a <strong className="text-white">{email}</strong>, receberá em instantes um email com um link para repor a palavra-passe.
              </p>
              <p className="text-white/40 font-body text-xs mt-3">O link é válido durante 1 hora.</p>
              <Link
                to="/login"
                className="inline-flex items-center gap-2 mt-6 text-[#FF5A00] hover:text-[#FF8534] font-display font-semibold uppercase text-xs tracking-widest"
              >
                <ArrowLeft className="w-4 h-4" />
                Voltar ao login
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} className="flex flex-col gap-3">
              <div>
                <label className="text-[10px] uppercase tracking-widest text-white/50 font-display block mb-1">Email da conta</label>
                <div className="relative">
                  <Mail className="w-4 h-4 text-white/40 absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none" />
                  <input
                    data-testid="forgot-email-input"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="nome@exemplo.pt"
                    autoComplete="email"
                    className="w-full bg-[#0E2452] border border-[#2F568F] text-white pl-11 pr-4 py-3 rounded-xl focus:outline-none focus:border-[#FF5A00]"
                    required
                  />
                </div>
              </div>
              <button
                data-testid="forgot-submit"
                type="submit"
                disabled={loading}
                className="mt-2 inline-flex items-center justify-center gap-2 bg-[#FF5A00] hover:bg-[#E65100] text-white font-display font-bold uppercase tracking-wider py-3 rounded-full transition-all disabled:opacity-50 active:scale-[0.98]"
              >
                {loading ? "A enviar..." : "Enviar link de reposição"}
                <ChevronRight className="w-4 h-4" />
              </button>
              <div className="text-center mt-3">
                <Link to="/login" className="text-white/60 hover:text-[#FF5A00] text-sm font-body inline-flex items-center gap-1">
                  <ArrowLeft className="w-3.5 h-3.5" />
                  Voltar
                </Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </main>
  );
};

export default ForgotPasswordPage;
